import { render } from "./Context.vue?vue&type=template&id=45eb0915&scoped=true"
import script from "./Context.vue?vue&type=script&lang=js"
export * from "./Context.vue?vue&type=script&lang=js"

import "./Context.vue?vue&type=style&index=0&id=45eb0915&scoped=true&lang=css"
import "./Context.vue?vue&type=style&index=1&id=45eb0915&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45eb0915"]])

export default __exports__